<div class="container py-4 py-md-5">

    <!-- Hero -->
    <div class="mb-4 mb-md-5 rounded-4"
        style="height:240px;background:url('assets/Images/carrousel/slide-03.jpg') center/cover;">
    </div>

    <h1 class="fw-bold mb-3">Servicios</h1>

    @if(currentRole == userRole.Company || !currentRole){
    @if(!currentRole){
    <h5 class="mt-4 mb-3 fw-bold">Para Empresas</h5>
    }
    <div class="row g-3 g-md-4">
        @for (s of companies(); track s.id) {
        <div class="col-12 col-md-6 col-lg-4">
            <a class="text-decoration-none text-reset d-block h-100" href="javascript:void(0)">
                <div class="border rounded-3 p-3 p-md-4 h-100 service-card">
                    <div class="service-icon mb-2">
                        <i class="fa-solid" [ngClass]="s.code"></i>
                    </div>
                    <div class="fw-bold mb-1">{{ s.text }}</div>
                    <p class="text-secondary mb-0" style="font-size:.95rem;">{{ s.description }}</p>
                </div>
            </a>
        </div>
        }
    </div>
    }

    @if(currentRole == userRole.Member || !currentRole){
    @if(!currentRole){
    <h5 class="mt-4 mb-3 fw-bold">Para Candidatos</h5>
    }
    <div class="row g-3 g-md-4">
        @for (s of candidates(); track s.id) {
        <div class="col-12 col-md-6 col-lg-4">
            <a class="text-decoration-none text-reset d-block h-100" href="javascript:void(0)">
                <div class="border rounded-3 p-3 p-md-4 h-100 service-card">
                    <div class="service-icon mb-2">
                        <i class="fa-solid" [ngClass]="s.code"></i>
                    </div>
                    <div class="fw-bold mb-1">{{ s.text }}</div>
                    <p class="text-secondary mb-0" style="font-size:.95rem;">{{ s.description }}</p>
                </div>
            </a>
        </div>
        }
    </div>
    }

</div>